<div class="imgRow">
    <div class="imgCol"><img #lImg [src]="row.images.lUrl"></div>
    <div class="imgCol"></div>
    <div class="imgCol"><img #rImg [src]="row.images.rUrl"></div>
</div>
<div class="heatmapWrp" #heatmapWrp>
    <lib-heatmap
            [config]="config"
            [coordinates]="coordinates"
            [max]="max"></lib-heatmap>
</div>

